import { useUnit } from 'effector-react';
import style from './AnalyticStyles.module.css';
import { $analyticsData } from '../../../models/organizationsModel/index.js';
import { formatNumber } from '../../../utils/number-manipulation.js';

function AnalyticsCards() {
  const analyticsData = useUnit($analyticsData);
  const staticData = [
    {
      key: 0,
      title: 'Количество компании',
      value: formatNumber(analyticsData.company_count_all),
    },
    {
      key: 1,
      title: '% Доли рынка по ОКЭД',
      value: analyticsData.company_count_filtered,
    },
    {
      key: 2,
      title: 'Сумма оплаченых налогов ',
      value: formatNumber(analyticsData.tax_sum_all),
    },
    {
      key: 3,
      title: '% доли оплаченых налогов  ',
      value: analyticsData.tax_sum_filtered,
    },
  ];

  return (
    <div className={style.analytics_cards_wrapper}>
      {staticData.map((item, index) => {
        return (
          <div key={`${item.key}-${index}`} className={style.analytics_card}>
            <div>{item.title}</div>
            <div className={style.analytics_card_value}>{item.value}</div>
          </div>
        );
      })}
    </div>
  );
}

export default AnalyticsCards;
